import React from 'react';
import { Modal } from 'react-bootstrap';
import { CreateSimpleFormPage } from '../pages/CreateSimpleFormPage';

interface FormModalProps {
  show: boolean;
  onHide: () => void;
  form: any;
  appId: string;
  onSuccess?: (data?: any) => void;
  prefill?: Record<string, any>;
  lockedFields?: string[];
}

export const FormModal: React.FC<FormModalProps> = ({
  show,
  onHide,
  form,
  appId,
  onSuccess,
  prefill,
  lockedFields,
}) => {
  if (!form) return null;

  return (
    <Modal show={show} onHide={onHide} size="lg" className="modal-blur" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{form.displayName}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <CreateSimpleFormPage
          form={form}
          appId={appId}
          embedded={true}
          prefill={prefill}
          lockedFields={lockedFields}
          onSuccess={(data) => {
            onSuccess?.(data);
            onHide();
          }}
        />
      </Modal.Body>
    </Modal>
  );
};
